<template>
  <div class="overlay">
    <div class="overlay__wrapper">
      <div class="overlay__content">
        <ul
          id="modal-content"
          class="modal__content-list modal__content-list--edit"
        >
          <li class="modal__content-item modal__content-item--title">
            <span class="modal__title">
              <span class="modal__title--limited"> „{{ job.name }}“ </span>
              <span class="modal__title--full">
                {{ this.config.lang["modal.control.edit-header"] }}
              </span>
            </span>
            <span
              id="modal-close"
              class="modal__close modal-close-action"
              @click="editJobClose"
            ></span>
          </li>
          <li class="modal__content-item modal__control">
            <p class="modal__control_header">
              {{ this.config.lang["modal.control.printsettings-header"] }}
            </p>
            <div class="form__formrow">
              <p class="form__row">
                <label
                  for="edit-parameter-colortype"
                  class="modal__control_label"
                >
                  {{
                    this.config.lang["modal.control.printsettings-label-color"]
                  }}
                </label>
                <select
                  id="edit-parameter-colortype"
                  name="parameter-colortype"
                  class="form__select--modalcontrol"
                >
                  <option
                    v-for="option in this.config.printparameter.single.colorType
                      .select"
                    :value="option.value"
                    :selected="option.value === job.colorType"
                    :data-image="option.image"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </p>
              <p class="form__row">
                <label
                  for="edit-parameter-printtype"
                  class="modal__control_label"
                >
                  {{
                    this.config.lang["modal.control.printsettings-label-print"]
                  }}
                </label>
                <select
                  id="edit-parameter-printtype"
                  name="parameter-printtype"
                  class="js-ms-dropdown form__select--modalcontrol"
                >
                  <option
                    v-for="option in this.config.printparameter.single.printType
                      .select"
                    :value="option.value"
                    :selected="option.value === job.printType"
                    :data-image="option.image"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </p>
            </div>

            <p class="modal__control_header">
              {{ this.config.lang["modal.control.papersettings-header"] }}
            </p>

            <div class="form__formrow">
              <p class="form__row">
                <label
                  for="edit-parameter-papertype"
                  class="modal__control_label"
                >
                  {{
                    this.config.lang[
                      "modal.control.printsettings-label-papertype"
                    ]
                  }}
                </label>
                <select
                  id="edit-parameter-papertype"
                  name="parameter-papertype"
                  class="js-ms-dropdown form__select--modalcontrol"
                >
                  <option
                    v-for="option in this.config.printparameter.single.paperType
                      .select"
                    :value="option.value"
                    :selected="option.value === job.paperType"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </p>
              <div class="form__formrow form__formrow--left">
                <p class="modal__control_label">
                  <span
                    v-html="this.config.lang['modal.control.sendc4-header']"
                  ></span>
                </p>
                <label
                  for="parameter-c4letter"
                  class="form__pincheckbox form__pincheckbox--pointer form__pincheckbox--oneline"
                >
                  <input
                    class="form__pincheckbox-input"
                    type="checkbox"
                    id="parameter-c4letter"
                    name="parameter-c4letter"
                    value="1"
                    v-model="c4letter"
                  />
                  <span class="form__pincheckbox-border"></span>
                  <span
                    class="form__pincheckbox-label form__pincheckbox-label--colorblue"
                    v-html="
                      this.config.lang['modal.control.sendc4-description']
                    "
                  ></span>
                </label>
              </div>
            </div>
            <div class="form__formrow" v-show="this.jobTypeId === 'bulk'">
              <p
                :class="{
                  ' form__row': true
                }"
              >
                <span class="modal__control_label text--left">
                  {{ this.config.lang["modal.control.return-envelope-header"] }}
                  <img
                    class="ebrief-tooltip tipso_style upload__section_header_tooltip"
                    src="/build/images/info-circle-darkgrey.svg"
                    data-tipso-key="return-envelope"
                    data-tipso-moveleft="2"
                    data-tipso-movetop="1"
                    alt="Info"
                    style="left: 7px; position: relative; top: 3px; height: 16px"
                  />
                </span>
                <label
                  for="bulk-parameter-return-envelope-edit"
                  class="form__pincheckbox form__pincheckbox--pointer form__pincheckbox--oneline"
                  :class="{
                    ' --disabled': job.recipients < 500 && !returnEnvelopeCheck
                  }"
                >
                  <input
                    :disabled="job.recipients < 500 && !returnEnvelopeCheck"
                    class="form__pincheckbox-input"
                    type="checkbox"
                    id="bulk-parameter-return-envelope-edit"
                    name="bulk-parameter-return-envelope-edit"
                    v-model="returnEnvelopeCheck"
                  />
                  <span class="form__pincheckbox-border"></span>
                  <span
                    class="form__pincheckbox-label form__pincheckbox-label--colorblue"
                  >
                    <span class="text--content-bold">
                      {{
                        this.config.lang[
                          "modal.control.return-envelope-checkbox-pt1"
                        ]
                      }}
                      <br v-if="returnEnvelopeCheck" />
                      <span
                        v-html="
                          this.config.lang[
                            'modal.control.return-envelope-checkbox-pt2'
                          ]
                        "
                      >
                      </span>
                    </span>
                  </span>
                </label>
                <label
                  v-if="returnEnvelopeCheck"
                  for="edit-parameter-envelopetype-1"
                  class="modal__control_label--return-envelope"
                >
                  {{
                    this.config.lang[
                      "modal.control.return-envelope-franking-header"
                    ]
                  }}
                </label>
                <select
                  id="edit-parameter-envelopetype-1"
                  name="parameter-papertype"
                  class="js-ms-dropdown form__select--modalcontrol form__hide"
                >
                  <option
                    v-for="option in this.config.printparameter.bulk
                      .envelopeType.select"
                    :value="option.value"
                    :selected="option.value === job.envelopeType"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </p>

              <p class="form__row --right" v-if="returnEnvelopeCheck">
                <label
                  for="bulk-parameter-return-address-edit"
                  class="modal__control_label--return-envelope"
                >
                  {{
                    this.config.lang[
                      "modal.control.return-envelope-textarea-header"
                    ]
                  }}
                </label>
                <textarea
                  id="bulk-parameter-return-address-edit"
                  name="parameter-return-address"
                  class="dd form__field--textarea-address "
                  maxlength="200"
                  v-model="returnAddress"
                  :placeholder="
                    this.config.lang[
                      'modal.control.return-envelope-textarea-placeholder'
                    ]
                  "
                  rows="3"
                >
                </textarea>
                <span
                  class="modal__control_label--char-count"
                  :class="{
                    ' --warning': addressCharLeft <= 10
                  }"
                >
                  noch {{ addressCharLeft }} Zeichen
                </span>
              </p>
            </div>
            <p
              class="modal__control_header"
              v-html="this.config.lang['modal.control.registeredletter-header']"
            ></p>
            <div class="form__formrow form__formrow--left">
              <label
                for="parameter-registeredletter"
                class="form__pincheckbox form__pincheckbox--pointer"
              >
                <input
                  class="form__pincheckbox-input"
                  type="checkbox"
                  id="parameter-registeredletter"
                  name="parameter-registeredletter"
                  value="1"
                  v-model="registeredLetter"
                />
                <span class="form__pincheckbox-border"></span>
                <span
                  v-if="this.config.userIsCompany"
                  class="form__pincheckbox-label form__pincheckbox-label--colorblue"
                  v-html="
                    this.config.lang[
                      'modal.control.registeredletter-label-business'
                    ]
                  "
                ></span>
                <span
                  v-if="!this.config.userIsCompany"
                  class="form__pincheckbox-label form__pincheckbox-label--colorblue"
                  v-html="
                    this.config.lang[
                      'modal.control.registeredletter-label-privat'
                    ]
                  "
                ></span>
              </label>
            </div>
            <div class="modal__control_action">
              <div
                v-if="validationError && returnEnvelopeCheck"
                class="form__validation_error"
              >
                <p id="errorOutput" class="form__errors">
                  {{ validationError }}
                </p>
              </div>
              <div class="modal__control_actionwrapper form__formrow">
                <p class="form__row">
                  <button
                    class="form__button form__button--green modal__control_submit"
                    @click="editJobEdit"
                  >
                    {{ this.config.lang["modal.control.edit-submit"] }}
                  </button>
                </p>
                <p class="form__row">
                  <button
                    class="modal__control_cancel modal-close-action modal__error-button modal__delete_action delete__from--success"
                    @click="editJobDelete"
                  >
                    <i class="icofont-trash"></i>
                    {{ this.config.lang["modal.control.preview-delete"] }}
                  </button>
                </p>
              </div>
              <p class="modal__control_actionwrapper">
                <a
                  href="javascript:void(0);"
                  id="#modal-close-single"
                  class="modal__control_cancel modal-close-action"
                  @click="editJobClose"
                >
                  {{ this.config.lang["modal.control.action-cancel"] }}
                </a>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import JobService from "../services/JobService";
import ReturnEnvelope from "./ReturnEnvelope";
import ValidationService from "../services/ValidationService";

export default {
  components: {
    ReturnEnvelope
  },
  name: "EditControl",
  props: {
    configdata: {
      type: Object,
      default: () => ({})
    },
    jobpid: {
      type: String,
      default: () => undefined
    }
  },
  watch: {
    jobpid: function(jobpid) {
      if (typeof jobpid !== "undefined") {
        if (this.$parent.jobs.hasOwnProperty(jobpid)) {
          this.currentjob = this.$parent.jobs[jobpid];
          let colortypeIndex = this.config.printparameter.selectIndex.colorType[
            this.currentjob.colorType
          ];
          $("#edit-parameter-colortype")
            .msDropdown()
            .data("dd")
            .set("selectedIndex", colortypeIndex);
          let printtypeIndex = this.config.printparameter.selectIndex.printType[
            this.currentjob.printType
          ];
          $("#edit-parameter-printtype")
            .msDropdown()
            .data("dd")
            .set("selectedIndex", printtypeIndex);

          let paperTypeIndex = this.config.printparameter.selectIndex.paperType[
            this.currentjob.paperType
          ];
          $("#edit-parameter-papertype")
            .msDropdown()
            .data("dd")
            .set("selectedIndex", paperTypeIndex);
          this.paperType = this.currentjob.paperType;
          this.registeredLetter =
            this.currentjob.shipmentType === this.shipmentTypes.registered;
          this.c4letter = this.currentjob.letterType === this.letterTypes.c4;
          if (this.currentjob.returnAddress) {
            this.returnEnvelopeCheck = true;
            this.envelopeType = this.currentjob.returnEnvelopeType;
            this.returnAddress = this.currentjob.returnAddress;

            let envelopeTypeIndex = this.config.printparameter.selectIndex
              .envelopeType[this.currentjob.returnEnvelopeType];
            $("#edit-parameter-envelopetype-1_msdd").css("display", "block");
            $("#edit-parameter-envelopetype-1")
              .msDropdown()
              .data("dd")
              .set("selectedIndex", envelopeTypeIndex);
          } else {
            $("#edit-parameter-envelopetype-1_msdd").css("display", "none");
            this.returnEnvelopeCheck = false;
          }
        } else {
          this.currentjob = undefined;
          console.error("Unknown jobpid in EditControl.");
        }
      } else {
        this.currentjob = undefined;
      }
    },
    registeredLetter: function(registeredLetter) {
      if (typeof this.currentjob !== "undefined") {
        if (
          this.registeredLetter &&
          this.currentjob.shipmentType === this.shipmentTypes.default
        ) {
          this.newShipmentType = this.shipmentTypes.registered;
        }
        if (
          this.registeredLetter &&
          this.currentjob.shipmentType === this.shipmentTypes.registered
        ) {
          this.newShipmentType = undefined;
        }
        if (
          !this.registeredLetter &&
          this.currentjob.shipmentType === this.shipmentTypes.default
        ) {
          this.newShipmentType = undefined;
        }
        if (
          !this.registeredLetter &&
          this.currentjob.shipmentType === this.shipmentTypes.registered
        ) {
          this.newShipmentType = this.shipmentTypes.default;
        }
      } else {
        // Nothing
      }
    },
    returnAddress() {
      this.validationError = "";
      if (this.currentjob?.recipients < 500 && this.returnEnvelopeCheck) {
        this.validationError = this.config.lang[
          "modal.control.return-envelope-less-than-500-letters"
        ];
      }
      if (this.returnAddress.includes(",")) {
        this.validationError = this.config.lang[
          "modal.control.return-envelope-address-no-comma-allowed"
        ];
      }
      this.addressCharLeft = 200 - this.returnAddress.length;
    }
  },
  data() {
    return {
      defaultjob: {
        pid: null,
        jobType: "single",
        name: "",
        colorType: 1,
        printType: 1,
        c4letter: "",
        shipmentType: configdata.printparameter.single.shipmentType,
        paperType: configdata.printparameter.single.paperType.default,
        returnEnvelopeCheck: false,
        envelopeType: "",
        returnAddress: configdata.printparameter.bulk.returnAddress ?? ""
      },
      validation: new ValidationService(configdata),
      validationError: "",
      currentjob: undefined,
      newColorTypeValue: undefined,
      newPrintTypeValue: undefined,
      newShipmentType: undefined,
      registeredLetter: false,
      c4letter: false,
      paperType: configdata.printparameter.single.paperType.default,
      returnEnvelopeCheck: false,
      envelopeType: "RU1",
      returnAddress: configdata.printparameter.bulk.returnAddress ?? "",
      addressCharLeft:
        200 - configdata.printparameter.bulk.returnAddress?.length ?? 0
    };
  },
  computed: {
    config: function() {
      return configdata;
    },
    job: function() {
      if (typeof this.currentjob !== "undefined") {
        return this.currentjob;
      }

      return this.defaultjob;
    },
    jobTypeId: function() {
      if (this.config.printparameter.bulk.jobType === this.job.jobType) {
        return "bulk";
      }
      return "single";
    },
    shipmentTypes: function() {
      return this.config.printparameter[this.jobTypeId].shipmentType;
    },
    letterTypes: function() {
      return this.config.printparameter[this.jobTypeId].letterTypes;
    }
  },
  methods: {
    editJobClose() {
      this.$emit("edit-job-close");
      this.hide();
    },
    editJobDelete(pid) {
      this.$emit("edit-job-delete", this.currentjob.pid);
      this.hide();
    },
    editJobEdit() {
      let data = {
        jobId: this.currentjob.id,
        colorType: undefined,
        printType: undefined,
        shipmentType: undefined,
        c4letter: undefined,
        paperType: this.currentjob.paperType
      };

      if (this.jobTypeId === "bulk") {
        data.returnAddress = "";
        data.returnEnvelopeType = null;

        if (this.currentjob.recipients < 500 && this.returnEnvelopeCheck) {
          this.validationError = this.config.lang[
            "modal.control.return-envelope-less-than-500-letters"
          ];
          return;
        }
      }

      let submitJob = false;
      if (
        typeof this.newColorTypeValue !== "undefined" &&
        this.newColorTypeValue !== this.currentjob.colorType
      ) {
        data.colorType = this.newColorTypeValue;
        submitJob = true;
      } else {
        data.colorType = this.currentjob.colorType;
      }
      if (
        typeof this.newPrintTypeValue !== "undefined" &&
        this.newPrintTypeValue !== this.currentjob.printType
      ) {
        data.printType = this.newPrintTypeValue;
        submitJob = true;
      } else {
        data.printType = this.currentjob.printType;
      }
      if (
        typeof this.newShipmentType !== "undefined" &&
        this.newShipmentType !== this.currentjob.shipmentType
      ) {
        data.shipmentType = this.newShipmentType;
        submitJob = true;
      } else {
        data.shipmentType = this.currentjob.shipmentType;
      }

      if (
        typeof this.c4letter !== "undefined" &&
        this.c4letter !== (this.letterTypes.c4 === this.currentjob.letterType)
      ) {
        data.c4letter = this.c4letter;
        submitJob = true;
      } else {
        data.c4letter = this.letterTypes.c4 === this.currentjob.letterType;
      }

      if (this.paperType !== this.currentjob.paperType) {
        submitJob = true;
        data.paperType = this.paperType;
      }

      if (this.returnEnvelopeCheck) {
        submitJob = true;
        data.returnAddress = this.returnAddress;
        data.returnEnvelopeType = this.envelopeType;
        let validated = this.validation.validateReturnEnvelope({
          returnAddress: this.returnAddress
        });
        if (!validated.success) {
          this.validationError = validated.errorMessage;
          return;
        }
      }
      if (!this.returnEnvelopeCheck && this.currentjob.returnEnvelopeType) {
        submitJob = true;
      }

      if (submitJob) {
        let job = this.currentjob;
        this.$emit("edit-job-close");
        this.$emit("show-spinner-modal");

        JobService.changePrintProperties(
          this.config.routes["ebrief_edit_job"],
          data
        ).then(response => {
          let error = false;
          if (response.success) {
            this.$set(job, "colorType", data.colorType);
            this.$set(job, "colortypemodifier", data.colorType.toLowerCase());
            this.$set(job, "printType", data.printType);
            this.$set(job, "printtypemodifier", data.printType.toLowerCase());
            this.$set(job, "shipmentType", data.shipmentType);
            this.$set(job, "paperType", data.paperType);
            this.$set(
              job,
              "shipmenttypemodifier",
              data.shipmentType.toLowerCase()
            );
            this.$set(job, "frontendstatus", "in-process");
            this.$set(job, "jobInfo", this.config.statuslang["in-process"]);
            if (data.c4letter) {
              this.$set(
                job,
                "letterType",
                this.config.printparameter.single.letterTypes.c4
              );
            } else {
              this.$set(job, "letterType", "null");
            }

            if (job.jobType === "SERIENBRIEF") {
              this.$set(job, "returnAddress", data.returnAddress);
              this.$set(job, "returnEnvelopeType", data.returnEnvelopeType);
            }
          } else {
            error = {
              header: response.error.header,
              text: response.error.text
            };
          }
          this.$emit("edit-job-edit", error);
        });
      } else {
        this.$emit("edit-job-close");
      }
      this.hide();
    },
    hide() {
      this.newColorTypeValue = undefined;
      this.newPrintTypeValue = undefined;
      this.newShipmentType = undefined;
      this.registeredLetter = false;
      this.c4letter = false;
      this.paperType = configdata.printparameter.single.paperType.default;
      if (this.jobTypeId === "bulk") {
        this.returnEnvelopCheck = false;
        this.envelopeType = "RU1";
        this.returnAddress = configdata.printparameter.bulk.returnAddress ?? "";
        $("#edit-parameter-envelopetype-1")
          .msDropdown()
          .data("dd")
          .set("selectedIndex", 0);
      }
      this.currentjob = undefined;
      this.validationError = "";
    }
  },
  mounted() {
    let that = this;
    $("#edit-parameter-colortype")
      .msDropdown({ visibleRows: 2 })
      .change(function() {
        that.newColorTypeValue = $(
          "#edit-parameter-colortype option:selected"
        ).val();
        that.newPrintTypeValue = $(
          "#edit-parameter-printtype option:selected"
        ).val();
      });

    $("#edit-parameter-printtype")
      .msDropdown({ visibleRows: 2 })
      .change(function() {
        that.newColorTypeValue = $(
          "#edit-parameter-colortype option:selected"
        ).val();
        that.newPrintTypeValue = $(
          "#edit-parameter-printtype option:selected"
        ).val();
      });

    $("#edit-parameter-papertype")
      .msDropdown({ visibleRows: 2 })
      .change(function() {
        that.paperType = $("#edit-parameter-papertype option:selected").val();
      });

    $("#edit-parameter-envelopetype-1")
      .msDropdown({ visibleRows: 3 })
      .change(function() {
        that.envelopeType = $(
          "#edit-parameter-envelopetype-1 option:selected"
        ).val();
      });
    // these here are needed to show and hide the return envelop select based on the checkbox
    // standard way doesn't work because 'msDropdown' creates a new element see "_msdd" suffix
    $("#bulk-parameter-return-envelope-edit").on("change", function() {
      that.returnEnvelopeCheck = this.checked;
      $("#edit-parameter-envelopetype-1_msdd").css("display", function() {
        return that.returnEnvelopeCheck ? "block" : "none";
      });
    });
  }
};
</script>
